module.exports = __webpack_public_path__ + "img/loading.de2e6b96.gif";